export const ORDER_DIRECTION_ASC = 'ASC'
export const ORDER_DIRECTION_DESC = 'DESC'



// WEBPACK FOOTER //
// ./src/types/order-direction.js